export default {
    dependencies: ['$element', 'profileservice'],
    callable(el, profileService) {
        const imageContainerEle = el.querySelector(
            '[data-profile-image-container]'
        );
        const imageButtonsContainerEle = imageContainerEle.querySelector(
            '[data-profile-image-buttons]'
        );
        const imageUploadButtonEle = imageButtonsContainerEle.querySelector(
            '[data-profile-image-change]'
        );
        const imageRemoveButtonEle = imageButtonsContainerEle.querySelector(
            '[data-profile-image-remove]'
        );
        const imageInputEle = imageButtonsContainerEle.querySelector(
            '[data-profile-image-input]'
        );

        const descriptionContainerEle = el.querySelector(
            '[data-profile-description-container]'
        );
        const descriptionTextareaEle = descriptionContainerEle.querySelector(
            '[data-profile-description-textarea]'
        );
        const descriptionUpdateButtonEle = descriptionContainerEle.querySelector(
            '[data-profile-description-update-button]'
        );

        let currentMessageEle;

        const CHANGE_DESCRIPTION_SUCCESS_MESSAGE =
            'Hepp! Vi har endret beskrivelsen din';
        const CHANGE_DESCRIPTION_ERROR_MESSAGE =
            'Usjda, vi greide ikke å lagre beskrivelsen din! Prøv igjen';
        const CHANGE_IMAGE_ERROR_MESSAGE =
            'Usjda, vi greide ikke å laste opp profilbildet ditt! Prøv igjen';
        const REMOVE_IMAGE_ERROR_MESSAGE =
            'Usjda, vi greide ikke å fjerne profilbildet ditt! Prøv igjen';

        init();

        function init() {
            imageInputEle.addEventListener('change', uploadImage);
            imageInputEle.addEventListener('click', event => {
                event.stopPropagation();
            }); // Prevent file picker from opening twice
            imageUploadButtonEle.addEventListener(
                'click',
                handleUploadButtonClick
            );
            imageUploadButtonEle.addEventListener(
                'keydown',
                handleUploadButtonKeydown
            );
            if (imageRemoveButtonEle) {
                imageRemoveButtonEle.addEventListener(
                    'click',
                    handleRemoveImageButtonClick
                );
            }
            descriptionUpdateButtonEle.addEventListener(
                'click',
                updateDescription
            );
        }

        function updateDescription() {
            setTextAreaDisabledState(true);

            profileService
                .changeDescription(descriptionTextareaEle.value)
                .then(() => {
                    showInfoMessage(
                        descriptionContainerEle,
                        CHANGE_DESCRIPTION_SUCCESS_MESSAGE
                    );
                })
                .catch(() => {
                    showErrorMessage(
                        descriptionContainerEle,
                        CHANGE_DESCRIPTION_ERROR_MESSAGE
                    );
                })
                .then(setTextAreaDisabledState.bind(this, false));
        }

        function setTextAreaDisabledState(disabled) {
            descriptionTextareaEle.disabled = disabled;
            descriptionUpdateButtonEle.disabled = disabled;
            descriptionUpdateButtonEle.classList.toggle('inprogress', disabled);
        }

        // Focus is on the fake button, so trigger a click on the input
        function handleUploadButtonClick() {
            imageInputEle.click();
        }

        function handleUploadButtonKeydown(event) {
            if (
                event.keyCode === 13 /* Enter */ ||
                event.keyCode === 32 /* Space */
            ) {
                event.stopPropagation();
                event.preventDefault();
                event.target.click();
            }
        }

        function handleRemoveImageButtonClick() {
            setButtonProgressState(imageRemoveButtonEle, true);

            // Set input value to null, otherwise uploading an image, removing it and trying to
            // upload it again does nothing (because the value does not change the 2nd time)
            imageInputEle.value = null;

            profileService.removeProfileImage().then(
                () => {
                    location.reload();
                },
                () => {
                    showErrorMessage(
                        imageContainerEle,
                        REMOVE_IMAGE_ERROR_MESSAGE
                    );
                    setButtonProgressState(imageRemoveButtonEle, false);
                }
            );
        }

        function uploadImage() {
            // If the user cancels selecting a file
            if (imageInputEle.files.length === 0) {
                return;
            }

            setButtonProgressState(imageUploadButtonEle, true);

            const newFile = imageInputEle.files[0];

            profileService.changeProfileImage(newFile).then(
                () => {
                    location.reload();
                },
                () => {
                    showErrorMessage(
                        imageContainerEle,
                        CHANGE_IMAGE_ERROR_MESSAGE
                    );
                    setButtonProgressState(imageUploadButtonEle, false);
                }
            );
        }

        function setButtonProgressState(ele, inProgress) {
            ele.classList.toggle('inprogress', inProgress);
            imageUploadButtonEle.classList.toggle('disabled', inProgress);
            imageInputEle.disabled = inProgress;
            if (imageRemoveButtonEle) {
                imageRemoveButtonEle.disabled = inProgress;
            }
        }

        function showMessage(element, message, className) {
            if (currentMessageEle) {
                currentMessageEle.remove();
            }

            currentMessageEle = document.createElement('p');
            currentMessageEle.textContent = message;
            currentMessageEle.classList.add(className);
            element.after(currentMessageEle);
        }

        function showInfoMessage(element, message) {
            showMessage(element, message, 'pea');
        }

        function showErrorMessage(element, message) {
            showMessage(element, message, 'cherry');
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/editProfile.js